// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__1u4s0","avatar":"Item_avatar__rhUPX","man":"Item_man__lvpIq","position":"Item_position__-yxjC"};